<template>
  <WidgetWrapp
    v-if="comment"
    class="best-comment"
    title="Комментарий дня"
  >
    <CommentPreview
      :comment="comment"
      @comment-click="sendAnalytics"
      @to-comment-click="sendAnalytics"
    />
  </WidgetWrapp>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import WidgetWrapp from '~/components/WidgetWrapp.vue';
  import CommentPreview from '~/components/CommentsWidget/CommentPreview.vue';
  import type { TWidgetComment } from '~/types/common';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';

  export default defineNuxtComponent({
    name: 'BestComment',

    components: { WidgetWrapp, CommentPreview },

    inject: {
      // Категория в которой происходит событие
      // Для аналитики
      eventCategory: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      comment: {
        type: Object as PropType<TWidgetComment>,
        default: null,
      },
    },

    computed: {
      currentSlug(): string {
        return getSlugFromUrl(this.$route.fullPath);
      },

      articleLink(): string {
        return this.comment.post_link || `/${this.comment.post?.slug}`;
      },

      commentLink(): string {
        const commentId: number | undefined = this.comment.comment_id || this.comment.id;
        return `${this.articleLink}#comment-${commentId}`;
      },
    },

    methods: {
      sendAnalytics(link: string) {
        this.$sendYandexMetrika({
          level1: 'Клик_комментарий_дня',
          level4: link,
        });
      },
    },
  });
</script>
